module.exports = __webpack_public_path__ + "static/Footprints.28d42e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Footprints.png
// module id = 572
// module chunks = 179562081087140